import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import AnalysisPage from "@/pages/analysis/page";
import ArticlePage from "@/pages/article/page";
import TopicsPage from "@/pages/topics/page";
import TopicPage from "@/pages/topic/page";
import FaqPage from "@/pages/faq/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/analysis",
    element: <AnalysisPage />,
  },
  {
    path: "/analysis/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/topics",
    element: <TopicsPage />,
  },
  {
    path: "/topic/:slug",
    element: <TopicPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;